
import React, { useEffect, useState } from "react";
import {
  Bar,
  Doughnut
} from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend
} from "chart.js";

import displayINRCurrency from "../helpers/displayCurrency";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend
);

const AdminDashboard = () => {

  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {

    const res = await fetch(
      "https://lappyshop.onrender.com/api/admin-stats",
      { credentials: "include" }
    );

    const data = await res.json();

    if (data.success) {
      setStats(data.data);
    }

  };

  if (!stats) return null;

  // Bar Chart
  const barData = {
    labels: ["Orders", "Products", "Low Stock"],
    datasets: [
      {
        label: "System Overview",
        data: [
          stats.totalOrders,
          stats.totalProducts,
          stats.lowStock
        ],
        backgroundColor: [
          "#3B82F6",
          "#10B981",
          "#EF4444"
        ]
      }
    ]
  };

  // Doughnut Chart
  const doughnutData = {
    labels: ["Revenue"],
    datasets: [
      {
        data: [stats.totalRevenue],
        backgroundColor: ["#6366F1"]
      }
    ]
  };

  return (

    <div className="p-4 md:p-6 bg-gray-100 min-h-screen">

      <h1 className="text-2xl md:text-3xl font-semibold mb-6">
        Admin Analytics Dashboard
      </h1>

      {/* Stats Cards */}

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">

        <div className="bg-white p-5 rounded shadow">
          <p className="text-gray-500 text-sm">
            Total Orders
          </p>
          <p className="text-xl md:text-2xl font-bold text-blue-600">
            {stats.totalOrders}
          </p>
        </div>

        <div className="bg-white p-5 rounded shadow">
          <p className="text-gray-500 text-sm">
            Revenue
          </p>
          <p className="text-xl md:text-2xl font-bold text-green-600">
            {displayINRCurrency(stats.totalRevenue)}
          </p>
        </div>

        <div className="bg-white p-5 rounded shadow">
          <p className="text-gray-500 text-sm">
            Products
          </p>
          <p className="text-xl md:text-2xl font-bold text-purple-600">
            {stats.totalProducts}
          </p>
        </div>

        <div className="bg-white p-5 rounded shadow">
          <p className="text-gray-500 text-sm">
            Low Stock
          </p>
          <p className="text-xl md:text-2xl font-bold text-red-600">
            {stats.lowStock}
          </p>
        </div>

      </div>

      {/* Charts */}

      <div className="grid md:grid-cols-2 gap-6 mb-8">

        <div className="bg-white p-6 rounded shadow">
          <h2 className="text-lg font-semibold mb-4">
            System Overview
          </h2>

          <Bar data={barData} />
        </div>

        <div className="bg-white p-6 rounded shadow">
          <h2 className="text-lg font-semibold mb-4">
            Revenue
          </h2>

          <Doughnut data={doughnutData} />
        </div>

      </div>

      {/* Recent Orders */}

      <div className="bg-white p-6 rounded shadow">

        <h2 className="text-lg font-semibold mb-4">
          Recent Orders
        </h2>

        <div className="overflow-x-auto">

          <table className="w-full text-left">

            <thead className="border-b">

              <tr>
                <th className="py-2">Customer</th>
                <th>Total</th>
                <th>Status</th>
              </tr>

            </thead>

            <tbody>

              {stats.recentOrders?.map((order) => (

                <tr
                  key={order._id}
                  className="border-b"
                >

                  <td className="py-2">
                    {order.userId?.name}
                  </td>

                  <td>
                    {displayINRCurrency(order.totalAmount)}
                  </td>

                  <td>
                    <span className="px-2 py-1 rounded bg-gray-200 text-sm">
                      {order.orderStatus}
                    </span>
                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

      </div>

    </div>

  );
};

export default AdminDashboard;